/**
 * components/UraMappingCell.js
 * ---------------------------------------------------------------------------
 * The "URA commodity" / "URA unit" cell shared by the category tables and the
 * unit table: the mapped code with URA's own name (and rate, for a commodity),
 * or a visible Unmapped state, plus an edit button when the table allows the
 * row to be re-mapped inline. Read-only when `onEdit` is not given (the
 * deactivated-categories table).
 */
import React from "react";
import { formatUraRate } from "../utilities/uraMapping";
import "./UraReferencePicker.css";

const UraMappingCell = ({ code, name, rate, onEdit, disabled = false, rowLabel = "" }) => {
  const mapped = Boolean(code);
  const rateText = mapped ? formatUraRate(rate) : null;
  const action = mapped ? "Change" : "Map";

  return (
    <div className="ura-cell">
      {mapped ? (
        <div className="ura-cell__text">
          <span className="ura-cell__code">
            {code}
            {rateText ? <span className="ura-cell__rate">{rateText}</span> : null}
          </span>
          {name ? (
            <span className="ura-cell__name" title={name}>
              {name}
            </span>
          ) : null}
        </div>
      ) : (
        <span className="ura-cell__unmapped">Unmapped</span>
      )}
      {onEdit ? (
        <button
          type="button"
          className="ura-cell__edit"
          onClick={onEdit}
          disabled={disabled}
          aria-label={`${action} URA code${rowLabel ? ` for ${rowLabel}` : ""}`}
        >
          {action}
        </button>
      ) : null}
    </div>
  );
};

export default UraMappingCell;
